// Inferencia automática del volumen (m³) de una partida de aislamiento MAT 4
// a partir de su descripción + unidad. Necesario porque la regla del manual
// (≥80% por VOLUMEN) requiere m³, pero las partidas suelen venir en m² (capa
// de aislamiento sobre superficie). El espesor está en la descripción
// (p.ej. "Lana mineral Ultracoustic 70 mm", "poliestireno extruido XPS 50 mm",
// "Impactodan 5 mm"). Se detecta con regex y se calcula m³ = m² × espesor/1000.

function norm(s) {
  if (!s) return ''
  return s.normalize('NFD').replace(/\p{Mn}/gu, '').toLowerCase()
}

// Detecta si la partida es aislamiento ACÚSTICO PURO (no térmico). Estos quedan
// fuera del alcance de MAT 4 según el manual (sólo se evalúa aislamiento térmico).
const SOLO_ACUSTICO = [
  /\bimpactodan\b/,                              // antiimpactos Danosa
  /\baislamiento\s+acustico\s+(impacto|anti)/,   // acústico anti-impacto
  /\baislamiento\s+(acustico|anti[\s-]?impactos)\b(?!.*termic)/, // acústico sin "térmico"
  /\bjunta\s+de\s+dilataci/,                     // junta de dilatación
  /\bcordon\s+de\s+(relleno|espuma|junta)/,      // relleno de junta
]
export function esAcusticoPuro(description) {
  const d = norm(description)
  // Si menciona "térmic" en cualquier parte, NO es puro acústico
  if (/\btermic/.test(d)) return false
  return SOLO_ACUSTICO.some(p => p.test(d))
}

// Extrae espesor en MM de la descripción. Devuelve mm o null.
// Patrones: "70 mm", "espesor 50 mm", "5 mm", "60 mm de espesor", "Lana mineral 45 mm"
const RE_MM     = /(\d{1,3})\s*mm\b/i
const RE_ESP_CM = /\b(\d{1,2})\s*cm\b/i
export function detectarEspesorMm(description) {
  const d = norm(description)
  let m = RE_MM.exec(d)
  if (m) return parseInt(m[1], 10)
  m = RE_ESP_CM.exec(d)
  if (m) return parseInt(m[1], 10) * 10
  return null
}

// Calcula m³ inferido desde descripción + unidad + cantidad.
// Devuelve: { m3, espesor_mm, fuente } donde fuente indica de dónde viene el valor.
//   - 'manual' si p.m3 ya está poblado
//   - 'unit_m3' si la unidad ya es m³
//   - 'derivado' si se calculó desde espesor + m² (o m × sección típica)
//   - 'sin_espesor' si NO se pudo inferir y la partida cuenta como 0 m³
//   - 'fuera_alcance' si es acústico puro (no térmico, no contabilizar)
export function inferM3(p) {
  if (esAcusticoPuro(p.description || '')) {
    return { m3: 0, fuente: 'fuera_alcance', espesor_mm: null }
  }
  // Si la unidad es m³, qty ya es el volumen
  if ((p.unit || '').toLowerCase() === 'm3') {
    const v = parseFloat(p.qty) || 0
    return { m3: v, fuente: 'unit_m3', espesor_mm: null }
  }
  // Si tiene m3 ya rellenado manualmente, respetar
  const manual = parseFloat(p.m3 || '') || 0
  if (manual > 0) return { m3: manual, fuente: 'manual', espesor_mm: null }

  const qty = parseFloat(p.qty) || 0
  if (qty <= 0) return { m3: 0, fuente: 'sin_qty', espesor_mm: null }
  const unit = (p.unit || '').toLowerCase()
  const espesor = detectarEspesorMm(p.description || '')

  if (unit === 'm2') {
    if (!espesor) return { m3: 0, fuente: 'sin_espesor', espesor_mm: null }
    return { m3: Math.round(qty * (espesor / 1000) * 100) / 100, fuente: 'derivado', espesor_mm: espesor }
  }
  if (unit === 'm' || unit === 'ml') {
    // Calorifugado tuberías: sección ~ π × (r_ext² − r_int²) ≈ depende del Ø.
    // Asumimos cilindro de 40 mm Ø × espesor → sección ~ π × 0,04 × espesor mm
    // Fórmula aproximada: m³ = m × π × diametro × espesor / 1e6
    if (!espesor) return { m3: 0, fuente: 'sin_espesor', espesor_mm: null }
    const diam_mm = 40 // estimación promedio tubería climatización
    const seccion_m2 = Math.PI * (diam_mm / 1000) * (espesor / 1000)
    return { m3: Math.round(qty * seccion_m2 * 1000) / 1000, fuente: 'derivado', espesor_mm: espesor }
  }
  // ud / otros → no podemos inferir sin más datos
  return { m3: 0, fuente: 'sin_inferir', espesor_mm: null }
}
